import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsOfService from './pages/legal/TermsOfService';
import CookiePolicy from './pages/legal/CookiePolicy';
import HowPayoutsWork from './pages/HowPayoutsWork';
import Features from './components/Features';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { TranslationProvider } from './contexts/TranslationContext';
import AdminPanel from './pages/AdminPanel';
import Users from './pages/AdminPanelPages/Users';
import SportIcons from './pages/AdminPanelPages/SportIcons';
import Leagues from './pages/AdminPanelPages/Leagues';
import PhilipSnatRunners from './pages/AdminPanelPages/PhilipSnatRunners';
import BecomeExpert from './pages/BecomeExpert';
import Dashboard from './pages/Dashboard';
import ExpertPanel from './pages/ExpertPanel';
import AddRecommendation from './pages/ExpertPanelPages/AddRecommendation';
import EditProfile from './pages/ExpertPanelPages/EditProfile';
import EditRecommendation from './pages/ExpertPanelPages/EditRecommendation';
import ManageMonetization from './pages/ExpertPanelPages/ManageMonetization';
import ExpertStatistics from './pages/ExpertPanelPages/Statistics';
import ForgotPassword from './pages/ForgotPassword';
import Generator from './pages/Generator';
import Home from './pages/Home';
import Hub from './pages/Hub';
import Login from './pages/Login';
import MyParlays from './pages/MyCoupons';
import PhilipSnatModels from './pages/PhilipSnatModels';
import PhilipSnatModelView from './pages/PhilipSnatModelView';
import PhilipSnatStats from './pages/PhilipSnatStats';
import Plans from './pages/Plans';
import GameRecommendations from './pages/GameRecommendations';
import Recommendations from './pages/Recommendations';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import ExpertProfile from './pages/SearchExpertPages/ExpertProfile';
import ExpertBuyAccess from './pages/SearchExpertPages/ExpertBuyAccess';
import ExpertStatsPage from './pages/expertStats/ExpertStatsPage';
import SearchExperts from './pages/SearchExpertPages/SearchExperts';
import Settings from './pages/Settings';
import Simulator from './pages/Simulator';
import Stats from './pages/Stats';

function App() {
  return (
    <TranslationProvider>
      <AuthProvider>
        <Router>
        <div className="app">
          <Navbar />
          <main className="main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/how-payouts-work" element={<HowPayoutsWork />} />
              <Route path="/philip-snat-models" element={<PhilipSnatModels />} />
              <Route path="/philip-snat-models/stats" element={<PhilipSnatStats />} />
              <Route path="/philip-snat-models/:file_id" element={<PhilipSnatModelView />} />
              <Route
                path="/hub"
                element={
                  <ProtectedRoute requireAdmin>
                    <Hub />
                  </ProtectedRoute>
                }
              />
              <Route path="/generator" element={<Generator />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/plans" element={<Plans />} />
              <Route
                path="/become-expert"
                element={
                  <ProtectedRoute>
                    <BecomeExpert />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/expert-panel"
                element={
                  <ProtectedRoute requireExpert>
                    <ExpertPanel />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/expert-panel/edit-profile"
                element={
                  <ProtectedRoute requireExpert>
                    <EditProfile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/expert-panel/recommendations/add"
                element={
                  <ProtectedRoute requireExpert>
                    <AddRecommendation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/expert-panel/recommendations/edit/:id"
                element={
                  <ProtectedRoute requireExpert>
                    <EditRecommendation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/expert-panel/monetization"
                element={
                  <ProtectedRoute requireExpert>
                    <ManageMonetization />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/expert-panel/statistics"
                element={
                  <ProtectedRoute requireExpert>
                    <ExpertStatistics />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin-panel"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminPanel />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={<Navigate to="/admin-panel/users" replace />}
                />
                <Route
                  path="users"
                  element={<Users />}
                />
                <Route
                  path="sport-icons"
                  element={<SportIcons />}
                />
                <Route
                  path="leagues"
                  element={<Leagues />}
                />
                <Route
                  path="philip-snat-runners"
                  element={<PhilipSnatRunners />}
                />
              </Route>
              <Route path="/experts/search" element={<SearchExperts />} />
              <Route
                path="/experts/:id"
                element={<ExpertProfile />}
              />
              <Route
                path="/experts/:id/stats"
                element={<ExpertStatsPage />}
              />
              <Route
                path="/experts/:id/buy"
                element={<ExpertBuyAccess />}
              />
              <Route path="/experts/recommendations" element={<Recommendations />} />
              <Route path="/experts/recommendations/:gameId" element={<GameRecommendations />} />
              <Route
                path="/experts/following"
                element={
                  <ProtectedRoute>
                    <Navigate to="/experts/search?followingOnly=1" replace />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/simulator"
                element={
                  <ProtectedRoute requireAdmin>
                    <Simulator />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile/dashboard"
                element={
                  <ProtectedRoute requireAdmin>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile/parlays"
                element={
                  <ProtectedRoute>
                    <MyParlays />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile/stats"
                element={
                  <ProtectedRoute requireAdmin>
                    <Stats />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile/settings"
                element={
                  <ProtectedRoute requireAdmin>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute requireAdmin>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/pro-features"
                element={
                  <ProtectedRoute requireAdmin requireSubscription requirePlan={1}>
                    <Features type="pro" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/elite-features"
                element={
                  <ProtectedRoute requireAdmin requireSubscription requirePlan={0}>
                    <Features type="basic" />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
      </AuthProvider>
    </TranslationProvider>
  );
}

export default App;
